import React, { useEffect, useState } from 'react';
import { KTIcon, KTSVG } from '../../../_metronic/helpers';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Cookies from 'js-cookie';
import axios from 'axios';
import { BASE_URL, BASE_URL_TWO } from '../../../utils';
import useFetchData from '../../hooks/getData';
import useGetDataWithFullUrl from '../../hooks/getDataWithFullUrl';
import { message } from "antd";
import { format } from 'formik';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import PopUp from '../Modal/Modal';


export default function EditInsuranceTable({ selectedData }) {

    // const [gender, setGender] = useState()
    // const [maritalStatus, setMeritalSatus] = useState();
    // const [nationality, setNationality] = useState()
    const navigate = useNavigate()

    // const [employeId, setEmployeName] = useState()

    const [shouldRefetch, setShouldRefetch] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [insuranceStatus, setInsuranceStatus] = useState(false);

    const id = Cookies.get('userId');
    const token = Cookies.get("token")

    const headers = {
        'token': token,
        'Content-Type': 'application/json'
    };

    // const employeList = useFetchData('getEmployeesList').fetchedData;

    // const { fetchedData } = useGetDataWithFullUrl(`${BASE_URL}getEmployeeDetailsForInsurance&employeeId=${employeId}&userId=${id}`, [shouldRefetch])

    // const details = fetchedData ? fetchedData[0] : '';



    // const d = '2000-12-04'

    // const originalDate = "8/4/1990";
    // const formattedDate = moment(selectedData?.dateOfBirth, "M/D/YYYY").format("YYYY-MM-DD");


    const initialValues = {
        policyNumber: selectedData ? selectedData?.policyNumber : '',
        insuranceName: selectedData ? selectedData?.insuranceName : '',
        insuranceAmount: selectedData ? selectedData?.insuranceAmount : '',
        familyMemberId: selectedData ? selectedData?.familyMemberId : ""
    };

    const showMessage = () => {
        message.destroy();
        message.success({
            content: 'Updated insurance staff',
            duration: 1
        });
    };

    const a = () => {
        message.info({
            content: 'Failed to update',
            duration: 1
        });
    };

    useEffect(() => {
        if (insuranceStatus) {
            formik.handleSubmit();
        }
    }, [insuranceStatus])

    const formik = useFormik({
        initialValues,
        // validationSchema: validationSchema,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            if (insuranceStatus) {
                axios.post(`${BASE_URL_TWO}`, {
                    sp: 'updInsuredstaffDetails',
                    userId: id,
                    policyNumber: values.policyNumber,
                    insuranceName: values.insuranceName,
                    insuranceAmount: values.insuranceAmount,
                    familyMemberId: selectedData?.familyMemberId
                }, { headers }).then(() => {
                    showMessage()
                    setShouldRefetch(prevState => !prevState)
                    setInsuranceStatus(false);
                    setModalOpen(false);
                    setTimeout(function () {
                        window.location.reload()
                    }, 1000);
                }).catch((error) => {
                    setInsuranceStatus(false);
                    setModalOpen(false);
                    if (error.response?.status === 401) {
                        Object.keys(Cookies.get()).forEach((cookieName) => {
                            Cookies.remove(cookieName, { path: '/' });
                        });
                        navigate('/error/login')
                    } else {
                        message.destroy();
                        message.error("Failed to Update")
                    }
                })
            }
        },
        enableReinitialize: true
    });

    return (
        <>
            <PopUp
                title="Update Insurance"
                message="Are you sure you want update the insurance ?"
                btnName="Update"
                setActionStatus={setInsuranceStatus}
                show={modalOpen}
                setShow={setModalOpen}
            />
            <div className="modal fade" id="kt_modal_3" tabIndex={-1} data-bs-backdrop="static" data-bs-keyboard="false" role="dialog">
                <form style={{ width: '100%' }} onSubmit={formik.handleSubmit} action="">

                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header bg-primary-subtle d-flex justify-content-between align-items-center">
                                <h5 className="modal-title text-primary">Enter Employee Insurance Details</h5>
                                <button type="button" className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className='row mb-1'>
                                    <label className='col-lg-4 col-form-label fw-bold fs-8 text-light-emphasis'>Policy Number</label>
                                    <div className='col-lg-6 fv-row'>
                                        <input
                                            type='number'
                                            className='form-control form-control-lg form-control-solid fs-7 bg-body-secondary'
                                            placeholder=''
                                            name='policyNumber'
                                            value={formik.values.policyNumber}
                                            onChange={formik.handleChange}
                                        />
                                        <span style={{ color: 'red' }} role='alert'>{formik.errors.policyNumber}</span>
                                    </div>
                                </div>


                                <div className='row mb-1'>
                                    <label className='col-lg-4 col-form-label fw-bold fs-8 text-light-emphasis'>Insurance Name</label>
                                    <div className='col-lg-6 fv-row'>
                                        <input
                                            type='text'
                                            className='form-control form-control-lg form-control-solid fs-7 bg-body-secondary'
                                            placeholder=''
                                            name="insuranceName"
                                            value={formik.values?.insuranceName}
                                            onChange={formik.handleChange}
                                        />
                                        <span style={{ color: 'red' }} role='alert'>{formik.errors.insuranceName}</span>
                                    </div>
                                </div>

                                <div className='row mb-1'>
                                    <label className='col-lg-4 col-form-label fw-bold fs-8 text-light-emphasis'>Insurance Amount</label>
                                    <div className='col-lg-6 fv-row'>
                                        <input
                                            type='number'
                                            className='form-control form-control-lg form-control-solid fs-7 bg-body-secondary'
                                            placeholder=''
                                            name="insuranceAmount"
                                            value={formik.values?.insuranceAmount}
                                            onChange={formik.handleChange}
                                        />
                                        <span style={{ color: 'red' }} role='alert'>{formik.errors.insuranceAmount}</span>

                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-light" data-bs-dismiss="modal">
                                    Close
                                </button>
                                <button type="submit" className="btn btn-primary" data-bs-dismiss="modal" onClick={()=>setModalOpen(true)}>
                                    Add
                                </button>
                            </div>
                        </div>
                    </div >
                </form >
            </div >
        </>
    )
}
